<template>
    <div class="box">
        <div v-for="(item,index) in exerciseType">
            <div class="row-bg el-row is-justify-space-between el-row--flex" style="background-color: #f9fafc;padding: 10px 0;margin: 10px 0 2px;align-items: center">
                <div class="el-col el-col-15">
                    {{item.itemName}}
<!--                    <el-input size="small" @change="editName" style="width: 100px" v-model="item.itemName" placeholder="请输入内容"></el-input>-->
                </div>
                <div class="row-bg-btn el-col el-col-9">
                    <a class="el-link el-link--primary" style="font-size: 18px; margin-left: 5px;">
                        <span class="el-link--inner" @click="updateRows('delete', index)"><i class="el-icon-delete"></i></span>
                    </a>
                    <a class="el-link el-link--primary" style="font-size: 18px; margin-left: 5px;">
                        <span class="el-link--inner" @click="dialogAdd(index,item)"><i class="el-icon-edit"></i></span>
                    </a>
                    <a class="el-link el-link--primary" style="font-size: 18px; margin-left: 5px;">
                        <span class="el-link--inner" @click="updateRows('up', index)"><i class="el-icon-top"></i></span>
                    </a>
                    <a class="el-link el-link--primary" style="font-size: 18px; margin-left: 5px;">
                        <span class="el-link--inner" @click="updateRows('down', index)"><i class="el-icon-bottom"></i></span>
                    </a>
                </div>
            </div>
            <div class="row-bg el-row is-justify-space-between el-row--flex" style="background-color: #f9fafc;padding: 10px 0;margin: 2px 0">
                <div class="el-col el-col-24">每题
                    <el-input-number @change="handleChange(index)"  :data-index="index" style="margin-left: 5px; margin-right: 5px; width: 100px;" v-model="item.everyScore" :precision="1" :step="0.5" size="mini"></el-input-number>
                    分
                </div>
            </div>
            <div class="row-bg el-row is-justify-space-between el-row--flex" style="background-color: #f9fafc;padding: 10px 0;margin: 2px 0 20px">
                <div class="el-col el-col-24" style="display: flex;align-items: center">共{{item.totalSize}}题，共{{item.totalScore}}分数</div><el-button @click="startDialog(index,item.exerciseType)" size="small" type="primary">添加试题</el-button>
            </div>
            <div class="el-divider el-divider--horizontal">

            </div>
        </div>
        <div>
            <div class="row-bg el-row is-justify-space-between el-row--flex">
                <div class="el-col el-col-24">总题数： {{allCountTm}}题</div>
                <div class="el-col el-col-24">当前总分： {{allScoreTm}}分</div>
            </div>
        </div>
        <GridSelectU v-show="false" style="width: 177px;" title="选择试题" labelName="exerciseName" :btn="true" ref="gridSelectU"
                     labelValue="id" :value="userId" :limit='99' size='small' placeholder='请选择试题'
                     @getValue="getValueUser" :columns="EDUCLASSCOURSTESTPAPER_code" :searchs="EDUCLASSCOURSTESTPAPER_search" dataListUrl="/edu/exercise/findList" entityBeanName="eduExercise" queryEntityUrl="/edu/exercise/get">
        </GridSelectU>
        <!-- 新增/查看/修改信息 -->
        <el-dialog
            title="创建题型"
            :visible.sync="showDialog"
            width="400px"
            @close="closeDialog"
            :append-to-body="true"
        >
            <div>
                <el-form
                    :model="tempItem"
                    ref="eduDialogForm"
                    :rules="rules"
                    label-width="90px"
                    :inline="true"
                    size="small"
                >
                    <el-form-item
                        label="题型分类"
                        prop="exerciseType"
                    >
                        <!--            <el-input-->
                        <!--              size="small"-->
                        <!--              v-model="eduKnowledge.parentId"-->
                        <!--              :disabled="eduKnowledgeState == 'check'"-->
                        <!--            ></el-input>-->
                        <el-select
                            clearable
                            style="width: 177px"
                            v-model="tempItem.exerciseType"
                            placeholder="请选择"
                            size="small"
                            :disabled="true"
                        >
                            <el-option
                                v-for="item in videoLocationList"
                                :label="item.value"
                                :value="item.key"
                                :key="item.key"
                            > </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="题型名称"
                        prop="itemName"
                    >
                        <el-input
                            size="small"
                            style="width: 177px"
                            v-model="tempItem.itemName"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div
                slot="footer"
                class="flex justify-end"
            >
                <el-button @click="closeDialog">关闭</el-button>
                <el-button
                    type="primary"
                    @click="editName"
                >确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import GridSelectU from '@/components/gridselect/gidselect.vue';
import { EDUCLASSCOURSTESTPAPER, EDUCLASSCOURSTESTPAPER_SEARCH } from '@/utils/constant';
import { get } from '@/utils/request';

export default {
    components: { GridSelectU },
    data() {
        return {
            exerciseType: [],
            userId: '',
            EDUCLASSCOURSTESTPAPER_code: EDUCLASSCOURSTESTPAPER,
            EDUCLASSCOURSTESTPAPER_search: EDUCLASSCOURSTESTPAPER_SEARCH,
            index: '',
            count: 0,
            showDialog: false,
            tempItem: {
                index: '',
                exerciseType: null,
                itemName: "",
            },
            videoLocationList: [],
            rules:{
                exerciseType: [
                    { required: true, message: '请选择题目类型', trigger: 'blur' },
                ],
                itemName: [
                    { required: true, message: '请输入题目名称', trigger: 'blur' },
                ]
            }
        }
    },
    computed: {
        allCountTm(){
            let count = 0;
            this.exerciseType.forEach(item => {
                count += item.totalSize;
            })
            return count;
        },
        allScoreTm(){
            let score = 0;
            this.exerciseType.forEach(item => {
                score += item.totalScore;
            })
            return score;
        }
    },
    created() {
        this.getEnums();
    },
    methods: {
        init(list){
            this.exerciseType = list;
        },
        getEnums(){
            get(`/edu/utils/getEnum?enumType=exercise_type`).then((res) => {
                if (res.success) {
                    this.videoLocationList = res.enumList;
                }
            });
        },
        dialogAdd(index,item){
            this.showDialog = true;
            this.tempItem = {
                index: index,
                exerciseType: item.exerciseType,
                itemName: item.itemName
            }
        },
        closeDialog(){
            this.showDialog = false;
            this.tempItem = {
                exerciseType: null,
                itemName: "",
                index: ''
            }
        },
        editName(){
            this.$emit('editName', this.tempItem.index,this.tempItem.itemName);
            this.closeDialog()
        },
        startDialog(index,exerciseType){
            console.log(index,exerciseType)
            this.index = index;
            this.$refs.gridSelectU.init(exerciseType);
        },
        getValueUser(val){
            console.log(val)
            this.userId = "";
            this.$emit('sublist', this.index, val)
        },
        handleChange(index){
            this.exerciseType[index].totalScore = this.exerciseType[index].totalSize * this.exerciseType[index].everyScore;
            this.$emit('subScore', index, this.exerciseType[index].everyScore)
        },
        updateRows(rows, index){
            let list = this.exerciseType[index];
            if(rows == 'up' && index > 0){
                let obj = this.exerciseType[index - 1];
                if(list.list.length != 0 && obj.list.length != 0){
                    this.count = 0;
                    this.count = obj.list[0].seq;
                    for (let listElement of list.list) {
                        listElement.seq = this.count++;
                    }
                    for (let objElement of obj.list) {
                        objElement.seq = this.count++;
                    }
                }
                obj.sort = index + 1
                list.sort = index;
                this.exerciseType[index - 1] = list;
                this.exerciseType[index] = obj;
                this.$emit('updateRows', this.exerciseType)
                this.$forceUpdate()
            }else if(rows == 'down' && index < this.exerciseType.length - 1){
                let obj = this.exerciseType[index + 1];
                if(list.list.length != 0 && obj.list.length != 0){
                    this.count = 0;
                    this.count = list.list[0].seq;
                    for (let objElement of obj.list) {
                        objElement.seq = this.count++;
                    }
                    for (let listElement of list.list) {
                        listElement.seq = this.count++;
                    }
                }
                obj.sort = index + 1
                list.sort = index + 2;
                this.exerciseType[index + 1] = list;
                this.exerciseType[index] = obj;
                this.$emit('updateRows', this.exerciseType)
                this.$forceUpdate()
            }else if (rows == 'delete'){
                this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.exerciseType.splice(index, 1);
                    this.count = 0;
                    for (let i = 0; i < index; i++) {
                        this.count += this.exerciseType[i].totalSize;
                    }
                    for (let i = index; i < this.exerciseType.length; i++){
                        for (let exerciseTypeElementElement of this.exerciseType[i].list) {
                            exerciseTypeElementElement.seq = ++this.count;
                        }
                    }
                    this.$emit('updateRows', this.exerciseType)
                    this.$forceUpdate()
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>